<template>
  <div class="text-left">
    <h5 class="text-center">
      <strong>{{ $t("name") }}:</strong> {{ title }}
      <span class="ml-5" v-if="supervisor"
        ><strong> Supervisor:</strong> {{ supervisor.username }}</span
      >
    </h5>
    <v-divider />
    <v-card>
      <v-form class="pa-6" ref="form">
        <v-col cols="12" class="py-0" v-if="similarities && similarities.length > 0">
          <v-alert
            class="mb-8 d-block mt-3"
            style="max-width: 100%; overflow: hidden; text-overflow: ellipsis;"
            color="yellow darken-4"
            icon="mdi-alert-box"
            type="warning"
            text
          >
            {{  $t('form.publication.similaritiesAdmin') }}
            <v-list light style="margin-left:-0.5em;">
              <v-list-item v-for="similarity in similarities" :key="similarity.id">
                <v-list-item-content>
                  <v-list-item-title dark>
                    <v-btn :to="'/manage/edit/publications/edit/' + similarity.id" target="_blank" outlined style="white-space: break-spaces;">{{ similarity.title }}</v-btn>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-alert>
        </v-col>
        <ReviewPublication :mod-op_id="modOp_id" :publication="publication" />
        <v-row>
          <v-col cols="12">
            <h3 class="mt-15 mb-0">
              {{ $t("title.communicationData") }}
            </h3>
          </v-col>
        </v-row>
        <h5>
          {{ $t("form.communication.congress_edition") }}
        </h5>
        <v-row>
          <v-col cols="12" lg="6" class="py-0">
            <v-combobox
              v-model="congressEditionSelected"
              :items="congressEditions"
              item-text="name"
              :label="$t('form.communication.congress_edition')"
              return-object
              outlined
              readonly
            />
          </v-col>
          <v-col cols="12" lg="6" class="py-0">
            <v-checkbox
              v-model="publication.communication.presented_on_main"
              class="big "
              readonly
              :label="$t('form.communication.mainConferenceDetail')"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" class="py-0">
            <h5>
              {{ $t("form.communication.date") }}
            </h5>
            <v-text-field
              outlined
              v-model="publication.communication.date"
              :label="$t('form.communication.date')"
              prepend-inner-icon="event"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="py-0">
            <h5>
              {{ $t("form.communication.type") }}
            </h5>
            <v-select
              outlined
              v-model="publication.communication.type"
              :label="$t('form.communication.type')"
              :items="communicationTypes"
              readonly
              item-value="value"
              item-text="text"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" class="py-0">
            <h5>
              {{ $t("form.communication.lecture_notes") }}
            </h5>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  v-model="publication.communication.lecture_notes"
                  readonly
                  :label="$t('form.communication.lecture_notes')"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" class="py-0">
            <h5>
              {{ $t("form.communication.prizes") }}
            </h5>
            <v-row>
              <v-col class="py-0">
                <v-text-field
                  v-model="publication.communication.prizes"
                  readonly
                  :label="$t('form.communication.prizes')"
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <h5>
          {{ $t("form.communication.feder_acknowledgements") }}
        </h5>
        <v-row>
          <v-col class="py-0">
            <v-checkbox
              class="big"
              v-model="publication.communication.feder_acknowledgements"
              :label="$t('form.federAcknowledgementsDetail')"
              readonly
            />
          </v-col>
        </v-row>

        <v-divider />
      </v-form>
    </v-card>
    <DirectorActions
      v-if="isAuthorize"
      :object_type="object_type"
      class="mt-6"
    />
    <SupervisorActions
      v-else
      :item="publication"
      :object_type="object_type"
      :form_name="form_name"
      :state="state"
      :supervisor="supervisor !== null ? supervisor.username : ''"
      @change-state-supervisor="onStateSupervisorChange"
      class="mt-6"
    />
  </div>
</template>

<script>
import axios from "axios";
import changeState from "../../../mixins/changeState";
import DirectorActions from "../../action_buttons/DirectorActions";
import SupervisorActions from "../../action_buttons/SupervisorActions";
import ReviewPublication from "./ReviewPublication";
import publication_model from "../../../mixins/model_utils/publication_model";

export default {
  mixins: [changeState, publication_model],
  components: {
    ReviewPublication,
    SupervisorActions,
    DirectorActions
  },

  props:{
    similarities: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    form_name: "newCommunicationForm",
    state: "",
    title: "",
    supervisor: "",
    object_id: null,
    object_type: "publication",
    congressEditionSelected: "",
    modOp_id: null,
    publication: {
      title: "",
      abstract: "",
      keywords: "",
      isbn: "",
      links: "",
      authorsrel: [],
      authors_text: "",
      commmunication: {}
    }
  }),

  created() {
    this.getCongressEditions();
    this.getCommunicationTypes();
    this.getPublication();
  },

  computed: {
    isAuthorize() {
      return this.$route.meta.authorize !== undefined;
    }
  },

  methods: {
    loadCongressEditionSelected(item) {
      if (typeof item == "number") {
        this.congressEditionSelected = this.congressEditions.filter(
          congressEdition => congressEdition.id === item
        )[0];
      } else {
        this.congressEditionSelected = item;
      }
    },

    getPublication() {
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/review/publication/" +
        this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.modOp_id = response.data.id;
          this.publication = response.data.data.user.publication;
          this.state = response.data.state;
          this.reject_comment = response.data.reject_comment;
          this.object_id = response.data.object_id;
          this.supervisor = response.data.supervisor;
          this.title = response.data.title;
          this.loadCongressEditionSelected(
            this.publication.communication.congress_edition
          );
          if(["vd","pv","pa"].includes(this.state.toLowerCase()) ){
            axios({ url: this.$store.state.endpoint + "/similar/publication", method: "GET", params: { search: this.publication.title } })
            .then(resp => {
              this.similarities = resp.data;
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    onStateSupervisorChange(state, supervisor) {
      this.state = state;
      this.supervisor = supervisor;
    }
  }
};
</script>
